import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { SKIP_SCROLL_INTO_VIEW_TAG, type NodeKey } from 'lexical';

// Takes the caret of a note's or a template's document to what `select`
// names and gives the document the focus, scrolling nothing: the caller
// shows the elements of the nodes `select` names, which it gets back.
export const useCaretJump = () => {
  const [editor] = useLexicalComposerContext();

  return (select: () => (NodeKey | null)[]) => {
    const target = { keys: [] as (NodeKey | null)[] };
    editor.update(
      () => {
        target.keys = select();
      },
      { discrete: true, tag: SKIP_SCROLL_INTO_VIEW_TAG },
    );
    editor.getRootElement()?.focus({ preventScroll: true });
    editor.focus();
    return target.keys.map((key) => (key ? editor.getElementByKey(key) : null));
  };
};
